module.exports = __webpack_public_path__ + "img/card-gri-1.4683f54e.svg";